export enum CampaignStep {
  details = "detail",
  select_brands = "brands",
  write_email = "email",
  review = "review",
}

export const CampaignStepOrders = [
  CampaignStep.details,
  CampaignStep.select_brands,
  CampaignStep.write_email,
  CampaignStep.review,
];

export const CampaignStepTitles: Record<CampaignStep, string> = {
  [CampaignStep.details]: "Details",
  [CampaignStep.select_brands]: "Select Brands",
  [CampaignStep.write_email]: "Write Emails",
  [CampaignStep.review]: "Review & Launch",
};

export const getActiveStep = (route: string) => {
  // Return a numeric representation of the step based on the route
  const step = CampaignStepOrders.findIndex((s) =>
    route?.includes(s.toLowerCase()),
  );
  if (step !== -1) {
    return step;
  }
  return 0;
};
